module.exports = __webpack_public_path__ + "static/img/img_anli_a1.69b6449c.png";